module.exports = __webpack_public_path__ + "static/media/sainsburys.8c22bbc5.svg";